<template>
  <div id="login-page">
    <div class="login-form center2D">
      <div class="fragment-logo">
        <div class="logo">
          <a id="logo" :style="`background-image: url('/img/logo-conicle-red.png')`"/>
        </div>
        <h4 class="m-0">Design system</h4>
      </div>
      <div>
        <CncButton @click="googleSignIn">Sign in with Google</CncButton>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, signInWithPopup, GoogleAuthProvider } from '../../firebase'

export default {
  mounted () {
    this.onAuthStateChanged()
  },
  methods: {
    googleSignIn () {
      const provider = new GoogleAuthProvider()
      signInWithPopup(auth, provider)
        .then((result) => {
          console.log('User signed in:', result.user)
        })
        .catch((error) => {
          console.error('Error during sign-in:', error)
          this.$notify.error({ title: 'Failed to sign in', message: error.message })
        })
    },
    onAuthStateChanged () {
      auth.onAuthStateChanged((user) => {
        if (user) {
          const authUser = JSON.stringify(user)
          sessionStorage.setItem('authUser', authUser)
          this.$store.commit('SET_STATE', { name: 'authUser', val: user })
          this.$notify({ title: 'Sign-in successful', type: 'success', message: ' Welcome!' })
          this.$router.replace('/')
        } else {
          // Optional for notification in case not loegged in yet
        }
      })
    }
  }
}

</script>

<style lang="scss">
#login-page {
  .login-form {
    display: flex;
    flex-direction: row;
    gap: 24px;
    padding: 24px;
    align-items: center;
  }

  .fragment-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    border-right: 1px solid #ddd;
    justify-content: center;

  .logo {
      position: relative;
      width: 180px;

      #logo {
        display: inline-block;
        width: 100%;
        height: 36px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }

  @media (max-width: $breakpoint-web-md) {
  .login-form {
      flex-direction: column;
      gap: 16px;

    .fragment-logo {
        border: none;
      }
    }
  }
}
</style>
